import { Tag } from "@zendeskgarden/react-tags";
import { ReactElement, useEffect, useMemo, useState } from "react";
import css from "./styles/vz-save-status.module.scss";
import { Check } from "@material-ui/icons";


export interface IVZSaveStatusProps {
    isSaving: boolean;
    lastSaved: Date;
}

export default function VZSaveStatus({isSaving, lastSaved}: IVZSaveStatusProps): ReactElement {
    const [now, setNow] = useState(() => Date.now());
    const [showCheck, setShowCheck] = useState(false);

    useEffect(() => {
        const lastSavedInterval = window.setInterval(() => setNow(Date.now()), 15000);
        return () => clearInterval(lastSavedInterval);
    }, []);

    useEffect(() => {
        if (isSaving) {
            return;
        }
        setShowCheck(true);
        const timeout = window.setTimeout(() => setShowCheck(false), 1200);
        return () => window.clearTimeout(timeout);
    }, [isSaving, lastSaved]);

    const {label, description, tagClass, textClass} = useMemo(() => {
        const formatTimeAgo = (date: Date): string => {
            const diffSeconds = Math.max(0, Math.floor((now - date.getTime()) / 1000));

            if (diffSeconds < 60) {
                return "Just now";
            }

            const diffMinutes = Math.floor(diffSeconds / 60);
            if (diffMinutes < 60) {
                return `${diffMinutes} minute${diffMinutes === 1 ? "" : "s"} ago`;
            }

            const diffHours = Math.floor(diffMinutes / 60);
            return `${diffHours} hour${diffHours === 1 ? "" : "s"} ago`;
        };

        if (isSaving) {
            return {
                label: "Saving...",
                description: formatTimeAgo(lastSaved),
                tagClass: `${css.tag} ${css.tagSaving}`,
                textClass: `${css.statusText} ${css.statusTextSaving}`
            };
        }

        return {
            label: "Saved",
            description: formatTimeAgo(lastSaved),
            tagClass: `${css.tag} ${css.tagSaved}`,
            textClass: css.statusText
        };
    }, [isSaving, lastSaved, now]);

    return (
        <div className={css.vzSaveStatus}>
            <Check className={`${css.checkIcon} ${showCheck ? css.checkIconVisible : ""}`} />
            <Tag size="small" className={tagClass} isPill>
                <span className={css.labelText}>{label}</span>
            </Tag>
            <span className={textClass}>{description}</span>
        </div>
    );
}
